<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>Collapse component allows you to toggle content on your pages with a bit of JavaScript and some
  classes. Flexible component that utilizes a handful of classes (from the <strong>required transitions
  component</strong>(<em>not yet implemented</em>)) for easy toggle behavior.</p>
  <p>The easiest way to add the collapse component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">collapse</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
